module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pgmonospaced"
  }, [_c('br', {
    staticClass: "calibre1"
  }), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "",
      "src": "Images/IMG0001.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre3",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("NOVICE")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_vm._v("by ")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_vm._v("James H. Schmitz")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre4"
  }, [_vm._v("A novice is one who is inexperienced—but"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nthat doesn't mean incompetent. Nor does it mean stupid!")])]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc1",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("illustrated by schoenherr")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67140bfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001_split_000.vue
// module id = 57
// module chunks = 0